import { ListingViewSidebar } from 'modules/listing/components/ListingView/Sidebar/ListingViewSidebar';
import { ListingViewSidebarContent } from 'modules/listing/components/ListingView/Sidebar/ListingViewSidebarContent';
import { ListingViewSidebarImage } from 'modules/listing/components/ListingView/Sidebar/ListingViewSidebarImage';
import { ListingViewSidebarLinks } from 'modules/listing/components/ListingView/Sidebar/ListingViewSidebarLinks';
import { ListingViewSidebarTitle } from 'modules/listing/components/ListingView/Sidebar/ListingViewSidebarTitle';
import type { ApiJob } from 'modules/listing/jobs/api/types/ApiJob';
import type { SearchContextHeaderData } from 'modules/search/containers/SearchContextHeader/SearchContextHeaderData';
import type { SearchSavedListingsStore } from 'modules/search/zustand-stores/searchSavedListingsStore';

import { ViewJobPageSidebarResults } from './ViewJobPageSidebarResults';

type Props = {
  job: ApiJob;
  applied: boolean;
  listingDetailsSearchResultsEnabled: boolean;
  searchContext: SearchContextHeaderData | null;
  isExpired: boolean;
  searchSavedListingsStore: SearchSavedListingsStore;
};

export function ViewJobPageSidebar({
  job,
  applied,
  listingDetailsSearchResultsEnabled,
  searchContext,
  isExpired,
  searchSavedListingsStore,
}: Props) {
  const {
    address,
    hasAts,
    org,
    firstPublished,
    name,
    type,
    remoteOptions,
    orgLogoOverride,
    orgNameOverride,
  } = job;

  const orgLogo = orgLogoOverride ?? org?.logo ?? null;
  const orgName = orgNameOverride ?? org?.name ?? null;
  const orgUrl = org?.url[CURRENT_LOCALE()] ?? null;

  if (listingDetailsSearchResultsEnabled) {
    return (
      <ListingViewSidebar>
        <ViewJobPageSidebarResults
          job={job}
          searchContext={searchContext}
          searchSavedListingsStore={searchSavedListingsStore}
        />
      </ListingViewSidebar>
    );
  }

  return (
    <ListingViewSidebar maxWidth={288}>
      <ListingViewSidebarImage
        orgLogo={orgLogo}
        orgURLForCurrentLocale={orgUrl}
        orgName={orgName}
      />

      <ListingViewSidebarTitle
        address={address}
        listingName={name}
        listingType={type}
        orgName={orgName}
        orgUrl={orgUrl}
        remoteOptions={remoteOptions}
      />

      <ListingViewSidebarContent
        applied={applied}
        firstPublished={firstPublished}
        listingType={type}
        hasAts={hasAts}
        isExpired={isExpired}
        isPreview={false}
      />

      <ListingViewSidebarLinks searchContext={searchContext} orgUrl={orgUrl} />
    </ListingViewSidebar>
  );
}
